/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Tests whether an object has a property
 */

export const hasProperty = <T extends object, K extends string>(
  object: T,
  key: K
): object is T & { [Key in K]: unknown } => {
  return key in object
}
